import { useState, useEffect, useRef } from 'react';
import { api } from '../api/client.js';
import { useAuth } from '../context/AuthContext.jsx';
import { useTenantScope } from '../context/TenantScopeContext.jsx';
import './PendingCheckinsBell.css';

export default function PendingCheckinsBell() {
    const { user } = useAuth();
    const { tenantId } = useTenantScope();
    const [open, setOpen] = useState(false);
    const [pending, setPending] = useState({ count: 0, people: [] });
    const panelRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const res = await api.getAlertSummary();
                const block =
                    res?.data?.pendingCheckins ??
                    res?.pendingCheckins ?? { count: 0, people: [] };
                const people = Array.isArray(block.people) ? block.people : [];
                const count = Number(block.count) || people.length;
                if (!cancelled) setPending({ count, people });
            } catch {
                if (!cancelled) setPending({ count: 0, people: [] });
            }
        }
        load();
        const t = setInterval(load, 120_000);
        const onFocus = () => load();
        window.addEventListener('focus', onFocus);
        return () => {
            cancelled = true;
            clearInterval(t);
            window.removeEventListener('focus', onFocus);
        };
    }, [tenantId, user?.id, user?.rol]);

    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, [open]);

    const count = Number(pending.count) || (pending.people?.length ?? 0);

    return (
        <div className="pending-bell" ref={panelRef}>
            <button
                type="button"
                className="pending-bell-btn"
                aria-label={`${count} personas sin check-in hoy`}
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                🔔
                {count > 0 ? <span className="pending-bell-badge">{count > 99 ? '99+' : count}</span> : null}
            </button>
            {open ? (
                <div className="pending-bell-panel" role="dialog" aria-label="Sin registro hoy">
                    <p className="pending-bell-title">Sin check-in hoy</p>
                    {count === 0 ? (
                        <p className="pending-bell-empty">Todos los operarios activos registraron llegada.</p>
                    ) : (
                        <ul className="pending-bell-list">
                            {(pending.people || []).map((p) => (
                                <li key={p.id}>
                                    <strong>{p.full_name}</strong>
                                    <span className="pending-bell-meta">
                                        {p.employee_code}
                                        {p.area_name ? ` · ${p.area_name}` : ''}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            ) : null}
        </div>
    );
}
